require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./shadow.js.shim.module$react.js");

require("./goog.object.object.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("helix.hooks.js");
goog.provide('helix.hooks');
helix.hooks.raw_use_effect = shadow.js.shim.module$react.useEffect;
helix.hooks.raw_use_layout_effect = shadow.js.shim.module$react.useLayoutEffect;
helix.hooks.raw_use_memo = shadow.js.shim.module$react.useMemo;
helix.hooks.raw_use_callback = shadow.js.shim.module$react.useCallback;
helix.hooks.raw_use_imperative_handle = shadow.js.shim.module$react.useImperativeHandle;
/**
 * Like `react/useState`, but the update function returned can be used similar
 *   to `swap!`.
 * 
 *   Example:
 *   ```
 *   (let [[state set-state] (use-state {:count 0})]
 * ;; ...
 * (set-state update :count inc))
 *   ```
 */

helix.hooks.use_state = function helix$hooks$use_state(initial) {
  var vec__22578 = shadow.js.shim.module$react.useState(initial);
  var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__22578, 0, null);
  var u = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__22578, 1, null);
  var updater = shadow.js.shim.module$react.useCallback(function () {
    var helix$hooks$use_state_$_updater = null;

    var helix$hooks$use_state_$_updater__1 = function helix$hooks$use_state_$_updater__1(x) {
      return u.cljs$core$IFn$_invoke$arity$1 ? u.cljs$core$IFn$_invoke$arity$1(x) : u.call(null, x);
    };

    var helix$hooks$use_state_$_updater__2 = function () {
      var G__22646__delegate = function G__22646__delegate(f, xs) {
        return helix$hooks$use_state_$_updater.cljs$core$IFn$_invoke$arity$1(function helix$hooks$use_state_$_updater_$_spread_updater(x) {
          return cljs.core.apply.cljs$core$IFn$_invoke$arity$3(f, x, xs);
        });
      };

      var G__22646 = function G__22646(f, var_args) {
        var xs = null;

        if (arguments.length > 1) {
          var G__22647__i = 0,
              G__22647__a = new Array(arguments.length - 1);

          while (G__22647__i < G__22647__a.length) {
            G__22647__a[G__22647__i] = arguments[G__22647__i + 1];
            ++G__22647__i;
          }

          xs = new cljs.core.IndexedSeq(G__22647__a, 0, null);
        }

        return G__22646__delegate.call(this, f, xs);
      };

      G__22646.cljs$lang$maxFixedArity = 1;

      G__22646.cljs$lang$applyTo = function (arglist__22648) {
        var f = cljs.core.first(arglist__22648);
        var xs = cljs.core.rest(arglist__22648);
        return G__22646__delegate(f, xs);
      };

      G__22646.cljs$core$IFn$_invoke$arity$variadic = G__22646__delegate;
      return G__22646;
    }();

    helix$hooks$use_state_$_updater = function helix$hooks$use_state_$_updater(f, var_args) {
      var xs = var_args;

      switch (arguments.length) {
        case 1:
          return helix$hooks$use_state_$_updater__1.call(this, f);

        default:
          var G__22649 = null;

          if (arguments.length > 1) {
            var G__22650__i = 0,
                G__22650__a = new Array(arguments.length - 1);

            while (G__22650__i < G__22650__a.length) {
              G__22650__a[G__22650__i] = arguments[G__22650__i + 1];
              ++G__22650__i;
            }

            G__22649 = new cljs.core.IndexedSeq(G__22650__a, 0, null);
          }

          return helix$hooks$use_state_$_updater__2.cljs$core$IFn$_invoke$arity$variadic(f, G__22649);
      }

      throw new Error('Invalid arity: ' + arguments.length);
    };

    helix$hooks$use_state_$_updater.cljs$lang$maxFixedArity = 1;
    helix$hooks$use_state_$_updater.cljs$lang$applyTo = helix$hooks$use_state_$_updater__2.cljs$lang$applyTo;
    helix$hooks$use_state_$_updater.cljs$core$IFn$_invoke$arity$1 = helix$hooks$use_state_$_updater__1;
    helix$hooks$use_state_$_updater.cljs$core$IFn$_invoke$arity$variadic = helix$hooks$use_state_$_updater__2.cljs$core$IFn$_invoke$arity$variadic;
    return helix$hooks$use_state_$_updater;
  }(), []);
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [v, updater], null);
};
/**
 * Like react/useRef. Supports accessing the "current" property via
 *   dereference (@) and updating the "current" property via `reset!` and
 *   `swap!`
 */


helix.hooks.use_ref = function helix$hooks$use_ref(x) {
  var ref = shadow.js.shim.module$react.useRef(null);

  if (ref.current == null) {
    ref.current = function () {
      var x22583 = {
        "current": x
      };
      x22583.cljs$core$IDeref$ = cljs.core.PROTOCOL_SENTINEL;

      x22583.cljs$core$IDeref$_deref$arity$1 = function (this$) {
        var this$__$1 = this;
        return this$__$1.current;
      };

      x22583.cljs$core$IReset$ = cljs.core.PROTOCOL_SENTINEL;

      x22583.cljs$core$IReset$_reset_BANG_$arity$2 = function (this$, v) {
        var this$__$1 = this;
        return goog.object.set(this$__$1, "current", v);
      };

      x22583.cljs$core$ISwap$ = cljs.core.PROTOCOL_SENTINEL;

      x22583.cljs$core$ISwap$_swap_BANG_$arity$2 = function (this$, f) {
        var this$__$1 = this;
        return goog.object.set(this$__$1, "current", function () {
          var G__22586 = this$__$1.current;
          return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(G__22586) : f.call(null, G__22586);
        }());
      };

      x22583.cljs$core$ISwap$_swap_BANG_$arity$3 = function (this$, f, a) {
        var this$__$1 = this;
        return goog.object.set(this$__$1, "current", function () {
          var G__22587 = this$__$1.current;
          var G__22588 = a;
          return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(G__22587, G__22588) : f.call(null, G__22587, G__22588);
        }());
      };

      x22583.cljs$core$ISwap$_swap_BANG_$arity$4 = function (this$, f, a, b) {
        var this$__$1 = this;
        return goog.object.set(this$__$1, "current", function () {
          var G__22591 = this$__$1.current;
          var G__22592 = a;
          var G__22593 = b;
          return f.cljs$core$IFn$_invoke$arity$3 ? f.cljs$core$IFn$_invoke$arity$3(G__22591, G__22592, G__22593) : f.call(null, G__22591, G__22592, G__22593);
        }());
      };

      x22583.cljs$core$ISwap$_swap_BANG_$arity$5 = function (this$, f, a, b, xs) {
        var this$__$1 = this;
        return goog.object.set(this$__$1, "current", cljs.core.apply.cljs$core$IFn$_invoke$arity$5(f, this$__$1.current, a, b, xs));
      };

      return x22583;
    }();
  } else {}

  return ref.current;
};
/**
 * Just react/useReducer.
 */


helix.hooks.use_reducer = function helix$hooks$use_reducer(var_args) {
  var G__22596 = arguments.length;

  switch (G__22596) {
    case 2:
      return helix.hooks.use_reducer.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return helix.hooks.use_reducer.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_reducer.cljs$core$IFn$_invoke$arity$2 = function (reducer, init_state) {
  return helix.hooks.use_reducer.cljs$core$IFn$_invoke$arity$3(reducer, init_state, undefined);
};

helix.hooks.use_reducer.cljs$core$IFn$_invoke$arity$3 = function (reducer, init_state, init) {
  return shadow.js.shim.module$react.useReducer(shadow.js.shim.module$react.useMemo(function () {
    if (!cljs.core.fn_QMARK_(reducer) && cljs.core.ifn_QMARK_(reducer)) {
      return function helix$hooks$wrap_ifn(state, action) {
        return reducer.cljs$core$IFn$_invoke$arity$2 ? reducer.cljs$core$IFn$_invoke$arity$2(state, action) : reducer.call(null, state, action);
      };
    } else {
      return reducer;
    }
  }, [reducer]), init_state, init);
};

helix.hooks.use_reducer.cljs$lang$maxFixedArity = 3;
/**
 * Just react/useContext
 */

helix.hooks.use_context = shadow.js.shim.module$react.useContext;

helix.hooks.wrap_fx = function helix$hooks$wrap_fx(f) {
  return function helix$hooks$wrap_fx_$_wrap_fx_return() {
    var x = f.cljs$core$IFn$_invoke$arity$0 ? f.cljs$core$IFn$_invoke$arity$0() : f.call(null);

    if (cljs.core.fn_QMARK_(x)) {
      return x;
    } else {
      return undefined;
    }
  };
};

helix.hooks.simple_body_QMARK_ = function helix$hooks$simple_body_QMARK_(body) {
  return cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.count(body), 1) && cljs.core.first(body) instanceof cljs.core.Symbol;
};

helix.hooks.determine_deps = function helix$hooks$determine_deps(deps) {
  var G__22605 = deps;
  var G__22605__$1 = G__22605 instanceof cljs.core.Keyword ? G__22605.fqn : null;

  switch (G__22605__$1) {
    case "once":
      return [];
      break;

    case "always":
      return undefined;
      break;

    case "auto-deps":
      throw new Error("Cannot use :auto-deps outside of macro.");
      break;

    default:
      return cljs.core.to_array(deps);
  }
};
/**
 * Like react/useEffect.  See `use-effect` for details on what `f`'s return values.  See namespace doc for `deps`.
 */


helix.hooks.use_effect_STAR_ = function helix$hooks$use_effect_STAR_(var_args) {
  var G__22611 = arguments.length;

  switch (G__22611) {
    case 1:
      return helix.hooks.use_effect_STAR_.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return helix.hooks.use_effect_STAR_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_effect_STAR_.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return shadow.js.shim.module$react.useEffect(helix.hooks.wrap_fx(f));
};

helix.hooks.use_effect_STAR_.cljs$core$IFn$_invoke$arity$2 = function (f, deps) {
  if (cljs.core.truth_(goog.DEBUG)) {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(deps, new cljs.core.Keyword(null, "auto-deps", "auto-deps", -2124919365))) {
      throw new Error("Can't use `:auto-deps` with `use-effect*`; use `use-effect` macro for that");
    } else {}
  } else {}

  return shadow.js.shim.module$react.useEffect(helix.hooks.wrap_fx(f), cljs.core.to_array(deps));
};

helix.hooks.use_effect_STAR_.cljs$lang$maxFixedArity = 2;
/**
 * Like `use-effect*` but instead calls react/useLayoutEffect.
 */

helix.hooks.use_layout_effect_STAR_ = function helix$hooks$use_layout_effect_STAR_(var_args) {
  var G__22615 = arguments.length;

  switch (G__22615) {
    case 1:
      return helix.hooks.use_layout_effect_STAR_.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return helix.hooks.use_layout_effect_STAR_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_layout_effect_STAR_.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return shadow.js.shim.module$react.useLayoutEffect(helix.hooks.wrap_fx(f));
};

helix.hooks.use_layout_effect_STAR_.cljs$core$IFn$_invoke$arity$2 = function (f, deps) {
  if (cljs.core.truth_(goog.DEBUG)) {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(deps, new cljs.core.Keyword(null, "auto-deps", "auto-deps", -2124919365))) {
      throw new Error("Can't use `:auto-deps` with `use-layout-effect*`; use `use-layout-effect` macro for that");
    } else {}
  } else {}

  return shadow.js.shim.module$react.useLayoutEffect(helix.hooks.wrap_fx(f), cljs.core.to_array(deps));
};

helix.hooks.use_layout_effect_STAR_.cljs$lang$maxFixedArity = 2;
/**
 * Like react/useMemo.  `f` is unchanged in meaning.  See namespace doc for
 *   `deps`.
 */

helix.hooks.use_memo_STAR_ = function helix$hooks$use_memo_STAR_(var_args) {
  var G__22623 = arguments.length;

  switch (G__22623) {
    case 1:
      return helix.hooks.use_memo_STAR_.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return helix.hooks.use_memo_STAR_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_memo_STAR_.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return shadow.js.shim.module$react.useMemo(f);
};

helix.hooks.use_memo_STAR_.cljs$core$IFn$_invoke$arity$2 = function (f, deps) {
  if (cljs.core.truth_(goog.DEBUG)) {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(deps, new cljs.core.Keyword(null, "auto-deps", "auto-deps", -2124919365))) {
      throw new Error("Can't use `:auto-deps` with `use-memo*`; use `use-memo` macro for that");
    } else {}
  } else {}

  return shadow.js.shim.module$react.useMemo(f, cljs.core.to_array(deps));
};

helix.hooks.use_memo_STAR_.cljs$lang$maxFixedArity = 2;
/**
 * `f` is a function which will be passed to react/useCallback.  See
 *   namespace doc for `deps`.
 */

helix.hooks.use_callback_STAR_ = function helix$hooks$use_callback_STAR_(var_args) {
  var G__22625 = arguments.length;

  switch (G__22625) {
    case 1:
      return helix.hooks.use_callback_STAR_.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return helix.hooks.use_callback_STAR_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_callback_STAR_.cljs$core$IFn$_invoke$arity$1 = function (f) {
  return shadow.js.shim.module$react.useCallback(f);
};

helix.hooks.use_callback_STAR_.cljs$core$IFn$_invoke$arity$2 = function (f, deps) {
  if (cljs.core.truth_(goog.DEBUG)) {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(deps, new cljs.core.Keyword(null, "auto-deps", "auto-deps", -2124919365))) {
      throw new Error("Can't use `:auto-deps` with `use-callback*`; use `use-callback` macro for that");
    } else {}
  } else {}

  return shadow.js.shim.module$react.useCallback(f, cljs.core.to_array(deps));
};

helix.hooks.use_callback_STAR_.cljs$lang$maxFixedArity = 2;
/**
 * Like react/useImperativeHandle.  `ref` and `f` are unchanged in meaning.
 *   See namespace doc for `deps`
 */

helix.hooks.use_imperative_handle_STAR_ = function helix$hooks$use_imperative_handle_STAR_(var_args) {
  var G__22629 = arguments.length;

  switch (G__22629) {
    case 2:
      return helix.hooks.use_imperative_handle_STAR_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return helix.hooks.use_imperative_handle_STAR_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.hooks.use_imperative_handle_STAR_.cljs$core$IFn$_invoke$arity$2 = function (ref, f) {
  return shadow.js.shim.module$react.useImperativeHandle(ref, f);
};

helix.hooks.use_imperative_handle_STAR_.cljs$core$IFn$_invoke$arity$3 = function (ref, f, deps) {
  if (cljs.core.truth_(goog.DEBUG)) {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(deps, new cljs.core.Keyword(null, "auto-deps", "auto-deps", -2124919365))) {
      throw new Error("Can't use `:auto-deps` with `use-imperative-handle*`; use `use-imperative-handle` macro for that");
    } else {}
  } else {}

  return shadow.js.shim.module$react.useImperativeHandle(ref, f, cljs.core.to_array(deps));
};

helix.hooks.use_imperative_handle_STAR_.cljs$lang$maxFixedArity = 3;
/**
 * Just react/useDebugValue
 */

helix.hooks.use_debug_value = shadow.js.shim.module$react.useDebugValue;
/**
 * Hook used for safely managing subscriptions, respecting Clojure equality.
 * 
 *   In order to avoid removing and re-adding subscriptions each time this hook is
 *   called, the parameters passed to this hook should be memoized in some way–
 *   either by wrapping the entire params object with `use-memo` or by wrapping the
 *   individual callbacks with `use-callback`.
 */

helix.hooks.use_subscription = function helix$hooks$use_subscription(p__22638) {
  var map__22639 = p__22638;
  var map__22639__$1 = (!(map__22639 == null) ? map__22639.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__22639.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__22639) : map__22639;
  var get_current_value = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__22639__$1, new cljs.core.Keyword(null, "get-current-value", "get-current-value", -1706578691));
  var subscribe = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__22639__$1, new cljs.core.Keyword(null, "subscribe", "subscribe", 416253756));
  var vec__22641 = shadow.js.shim.module$react.useState(function () {
    return {
      "get-current-value": get_current_value,
      "subscribe": subscribe,
      "value": get_current_value.cljs$core$IFn$_invoke$arity$0 ? get_current_value.cljs$core$IFn$_invoke$arity$0() : get_current_value.call(null)
    };
  });
  var state = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__22641, 0, null);
  var set_state = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__22641, 1, null);
  shadow.js.shim.module$react.useEffect(function () {
    var did_unsubscribe = {
      "value": false
    };

    var check_for_updates = function helix$hooks$use_subscription_$_check_for_updates() {
      if (cljs.core.not(goog.object.get(did_unsubscribe, "value"))) {
        var value = get_current_value.cljs$core$IFn$_invoke$arity$0 ? get_current_value.cljs$core$IFn$_invoke$arity$0() : get_current_value.call(null);

        var G__22644 = function G__22644(prev) {
          if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(get_current_value, goog.object.get(prev, "get-current-value")) || cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(subscribe, goog.object.get(prev, "subscribe"))) {
            return prev;
          } else {
            if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(value, goog.object.get(prev, "value"))) {
              return prev;
            } else {
              return {
                "get-current-value": goog.object.get(prev, "get-current-value"),
                "subscribe": goog.object.get(prev, "subscribe"),
                "value": value
              };
            }
          }
        };

        return set_state.cljs$core$IFn$_invoke$arity$1 ? set_state.cljs$core$IFn$_invoke$arity$1(G__22644) : set_state.call(null, G__22644);
      } else {
        return null;
      }
    };

    var unsubscribe = subscribe.cljs$core$IFn$_invoke$arity$1 ? subscribe.cljs$core$IFn$_invoke$arity$1(check_for_updates) : subscribe.call(null, check_for_updates);
    check_for_updates();
    return function () {
      goog.object.set(did_unsubscribe, "value", true);
      return unsubscribe.cljs$core$IFn$_invoke$arity$0 ? unsubscribe.cljs$core$IFn$_invoke$arity$0() : unsubscribe.call(null);
    };
  }, [get_current_value, subscribe]);

  if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(get_current_value, goog.object.get(state, "get-current-value")) || cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(subscribe, goog.object.get(state, "subscribe"))) {
    var value = get_current_value.cljs$core$IFn$_invoke$arity$0 ? get_current_value.cljs$core$IFn$_invoke$arity$0() : get_current_value.call(null);
    var G__22645_22676 = {
      "get-current-value": get_current_value,
      "subscribe": subscribe,
      "value": value
    };
    set_state.cljs$core$IFn$_invoke$arity$1 ? set_state.cljs$core$IFn$_invoke$arity$1(G__22645_22676) : set_state.call(null, G__22645_22676);
    return value;
  } else {
    return goog.object.get(state, "value");
  }
};

Object.defineProperty(module.exports, "use_ref", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_ref;
  }
});
Object.defineProperty(module.exports, "use_subscription", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_subscription;
  }
});
Object.defineProperty(module.exports, "use_memo_STAR_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_memo_STAR_;
  }
});
Object.defineProperty(module.exports, "use_reducer", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_reducer;
  }
});
Object.defineProperty(module.exports, "use_callback_STAR_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_callback_STAR_;
  }
});
Object.defineProperty(module.exports, "raw_use_layout_effect", {
  enumerable: false,
  get: function get() {
    return helix.hooks.raw_use_layout_effect;
  }
});
Object.defineProperty(module.exports, "raw_use_imperative_handle", {
  enumerable: false,
  get: function get() {
    return helix.hooks.raw_use_imperative_handle;
  }
});
Object.defineProperty(module.exports, "wrap_fx", {
  enumerable: false,
  get: function get() {
    return helix.hooks.wrap_fx;
  }
});
Object.defineProperty(module.exports, "simple_body_QMARK_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.simple_body_QMARK_;
  }
});
Object.defineProperty(module.exports, "use_imperative_handle_STAR_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_imperative_handle_STAR_;
  }
});
Object.defineProperty(module.exports, "determine_deps", {
  enumerable: false,
  get: function get() {
    return helix.hooks.determine_deps;
  }
});
Object.defineProperty(module.exports, "use_layout_effect_STAR_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_layout_effect_STAR_;
  }
});
Object.defineProperty(module.exports, "use_effect_STAR_", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_effect_STAR_;
  }
});
Object.defineProperty(module.exports, "raw_use_callback", {
  enumerable: false,
  get: function get() {
    return helix.hooks.raw_use_callback;
  }
});
Object.defineProperty(module.exports, "raw_use_effect", {
  enumerable: false,
  get: function get() {
    return helix.hooks.raw_use_effect;
  }
});
Object.defineProperty(module.exports, "use_state", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_state;
  }
});
Object.defineProperty(module.exports, "use_context", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_context;
  }
});
Object.defineProperty(module.exports, "use_debug_value", {
  enumerable: false,
  get: function get() {
    return helix.hooks.use_debug_value;
  }
});
Object.defineProperty(module.exports, "raw_use_memo", {
  enumerable: false,
  get: function get() {
    return helix.hooks.raw_use_memo;
  }
});